import { CurrencyPipe, DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { Page } from "@models/page";
import { TaskRequest, TaskType } from "@models/task-request";
import { PaginatorModule, PaginatorState } from "primeng/paginator";
import { SkeletonModule } from "primeng/skeleton";
import { TableModule } from "primeng/table";
import { RequestStatusEnumPipe } from "../../../shared/pipes/request-status-enum.pipe";
import { TaskTypePipe } from "../../../shared/pipes/task-type.pipe";

@Component({
  selector: "app-solicitations-table",
  imports: [
    CurrencyPipe,
    DatePipe,
    TableModule,
    MatButtonModule,
    MatIconModule,
    PaginatorModule,
    SkeletonModule,
    RequestStatusEnumPipe,
    TaskTypePipe,
  ],
  templateUrl: "./solicitations-table.component.html",
  styleUrl: "./solicitations-table.component.scss",
})
export class SolicitationsTableComponent {
  first = 0;
  rows = 20;

  @Input({ required: true }) data: Page<TaskRequest> | null = null;

  @Output() viewDetailsClick = new EventEmitter<TaskRequest>();
  @Output() pageChange = new EventEmitter<PaginatorState>();

  requestedAmount(task: TaskRequest): number | null {
    if (task.task_type !== TaskType.WITHDRAWAL) return null;

    const amount = Number(task.amount);
    return Number.isFinite(amount) ? amount : null;
  }
}
